

import { Component, OnInit , Inject} from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { RptloanpopupComponent } from "../../../shared/popup/rptloanpopup/rptloanpopup.component";

import { CommonmastersService } from "../../../../commonmasters/commonmasters.service";
import { PrintdemandsheetService } from "../../../shared/print/printdemandsheet.service";

@Component({
  selector: 'app-rptdemandsheetpopup',
  templateUrl: './rptdemandsheetpopup.component.html',
  styleUrls: ['./rptdemandsheetpopup.component.css']
})
export class RptdemandsheetpopupComponent implements OnInit {
  
  BranchList: any[] = [];
  CentreList: any[] = [];
  IsCentreORCustomerWise : number;

  constructor(public dialogRef: MatDialogRef<RptloanpopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private CommonmastersService: CommonmastersService,
    private printdemandsheetService: PrintdemandsheetService,
    // public datePipe: DatePipe,
    ) { }

  ngOnInit() {

    this.GetBranch();
    // this.GetCentre();
   this.data.BranchId = 0;
   this.data.CentreId = 0;
   this.data.IsCentreORCustomerWise = 0;
  }

  GenerateReports(): void {
    
    this.data.ReportName = "DemandSheetReport";
    this.printdemandsheetService.GenerateReport(this.data);
    this.dialogRef.close();
  }

  GetBranch() {
    this.CommonmastersService.GetBranchList().subscribe(data => {
      this.BranchList = data;
      data.BranchId = 0;
    })
  }

  SelectCentre(branchId : any){
    this.CommonmastersService.FetchCentersBybranchId(branchId).subscribe(data => {
      this.CentreList = data;
    })
  }
  
  // GetCentre() {
  //   this.CommonmastersService.FetchCenterList().subscribe(data => {
  //     this.CentreList = data;

  //     data.CentreId =0;
  //   })
  // }

}

